import React from "react";
import DistributionTable from "./distributionTable";

const Table = ({ record }) => {
  return (
    <DistributionTable
      parentRecordID={record.id}
      doc_distributions={record.doc_distributions}
    />
  );
};

export default Table;
